const baseModuleMenu = [
    {
        path: '/baseModule/indexHomePage',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexHomePage/index')
    },
    {
        path: '/baseModule/indexLesseeUser',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexLesseeUser/index')
    },
    {
        path: '/baseModule/indexLesseeDepartment',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexLesseeDepartment/index')
    },
    {
        path: '/baseModule/indexLesseeRole',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexLesseeRole/index')
    },
    {
        path: '/baseModule/indexExternalLinkUser',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexExternalLinkUser/index')
    },
    {
        path: '/baseModule/indexEmailAccount',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexEmailAccount/index')
    },
    {
        path: '/baseModule/indexApplication',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexApplication/index')
    },
    {
        path: '/baseModule/indexAuthority',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexAuthority/index')
    },
    {
        path: '/baseModule/indexAuditLog',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexAuditLog/index')
    },
    {
        path: '/baseModule/indexLesseeInformation',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexLesseeInformation/index')
    },
    {
        path: '/baseModule/indexDigitalWorkCard',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexDigitalWorkCard/index')
    },
    {
        path: '/baseModule/indexDissolutionLessee',
        component: () => import(/* webpackChunkName: "baseModule" */ '@/pages/baseModule/indexDissolutionLessee/index')
    },
]

export default baseModuleMenu
